import styled from "styled-components";
import { getColor } from "views/resources/theme";

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px;
	/* margin-left: 20px; */
	width: 300px;
	height: 100px;
	min-width: 200px;
	margin-bottom: ${(props) => (props.desktop ? "0px" : 0)};
	background-color: ${(props) => {
		if (props.isDisabled) {
			return getColor("disabled_color");
		}
		return props.type === "tickets"
			? getColor("blue_bg")
			: getColor("secondary");
	}};

	position: relative;
	border-radius: 10px;
	color: ${(props) =>
		props.isDisabled ? getColor("disabled_font") : getColor("bg")};
	svg {
		fill: ${(props) =>
			props.isDisabled ? getColor("disabled_font") : getColor("bg")};
	}

	.waitingRoomIcon svg {
		fill: transparent;
		width: 26px;
		height: 26px;
	}

	&::before,
	&::after {
		display: block;
		position: absolute;
		margin: 0;
		padding: 0;
		bottom: 40px;
		background-color: #fff;
		content: "";
		width: 20px;
		height: 20px;
		border-radius: 100%;
		z-index: 100;
	}
	&::before {
		left: -10px;
		border-top-right-radius: 110px;
		border-bottom-right-radius: 110px;
		box-shadow: inset -2px 0px 0px rgb(0 0 0 / 5%);
	}
	&::after {
		right: -10px;
		border-top-left-radius: 110px;
		border-bottom-left-radius: 110px;
		box-shadow: inset 2px 0px 0px rgb(0 0 0 / 5%);
	}

	/* :active {
		background-color: ${(props) => {
		// if (props.isDisabled) {
		// 	return getColor("disabled_color");
		// }
		return props.type === "tickets" ? "#0050b3" : getColor("purple_hover");
	}};
	} */

	&:hover {
		cursor: pointer;
		background-color: ${(props) => {
			if (props.isDisabled) {
				return getColor("disabled_color");
			}
			return props.type === "tickets"
				? getColor("blue_hover")
				: getColor("purple_hover");
		}};
	}
	& h5 {
		color: ${(props) =>
			props.isDisabled ? getColor("disabled_font") : getColor("bg")};
		margin: 0;
	}
	.text__button-container {
		margin-left: 15px;
		width: ${(props) => (props.virtualRoom ? "190px" : "215px")};
		h5 {
			text-align: ${(props) => (props.virtualRoom ? "left" : "")};
		}
	}
	.loading_wrapper {
		display: flex;
		flex-direction: column;
		font-size: 16px;
	}
	.text__container-with-ticket {
		text-align: center;
		h1 {
			margin: 0;
			color: ${getColor("bg")};
			text-align: center;
		}
	}
`;
